export enum ModalTranslationTypes {
    Unknown,
    NewsletterConfirm,
    RemoveDiscussionItem,
    SetDiscussionItemAsAnswered,
    SubmissionVersionOutdated,
    ChallengeDeadlineExpiredWhileUpdatingConceptSubmission,
    ChallengeDeadlineExpiredWhileUpdatingSubmittedSubmission
}